"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledActionsLabel = exports.StyledActionsWrapper = exports.StyledActionContent = exports.StyledActionItem = void 0;
const theme_1 = require("@icr-ui/theme");
const utils_1 = require("@icr-ui/utils");
const styled_components_1 = __importStar(require("styled-components"));
const general_1 = require("../../general");
exports.StyledActionItem = (0, styled_components_1.default)(general_1.Typography) `
  ${({ colorVariant }) => {
    const isPrimary = !colorVariant || colorVariant === 'primary';
    return (0, styled_components_1.css) `
      font-weight: 600;
      width: 100%;
      padding: ${(0, utils_1.pxToRem)(25)} 0;
      background-color: white;
      transition: all 0.3s ease-out;
      cursor: pointer;
      color: ${isPrimary ? theme_1.primary.main : theme_1.secondary.main};
      &:hover {
        color: ${isPrimary ? theme_1.primary.dark : theme_1.secondary.dark};
      }
      & + & {
        border-top: 1px solid ${theme_1.grayScale[200]};
      }
      &:first-of-type {
        padding-top: 0;
      }
      &:last-of-type {
        padding-bottom: 0;
      }
    `;
}}
`;
exports.StyledActionContent = (0, styled_components_1.default)(general_1.Flexbox) `
  position: absolute;
  top: 2rem;
  right: 0;
  max-height: 0;
  min-width: ${(0, utils_1.pxToRem)(335)};
  background-color: white;
  z-index: 999;
  overflow: hidden;
  border-radius: ${theme_1.spacings.s2};
  padding: 0;
  box-shadow: ${theme_1.defaultTheme.shadows.default(theme_1.grayScale[900])};
  transition: all 0.2s linear;

  * {
    opacity: 0;
    transition: opacity 0.2s linear;
  }
`;
exports.StyledActionsWrapper = (0, styled_components_1.default)(general_1.Flexbox) `
  ${({ isOpen, customStyles }) => {
    return (0, styled_components_1.css) `
      position: relative;
      transition: all 0.2s ease-out;
      svg {
        cursor: pointer;
        &:hover {
          path:nth-child(1) {
            stroke: ${theme_1.primary.dark};
          }
          path:nth-child(2) {
            fill: ${theme_1.primary.dark};
          }
        }
        path {
          transition: all 0.2s;
        }
      }

      ${exports.StyledActionContent} {
        ${isOpen &&
        (0, styled_components_1.css) `
          padding: ${theme_1.spacings.s7} ${theme_1.spacings.s6};
          max-height: 600px;
          * {
            opacity: 1;
          }
        `}
      }

      ${customStyles || {}};
    `;
}}
`;
exports.StyledActionsLabel = (0, styled_components_1.default)(general_1.Typography) `
  display: inline-block;
`;
//# sourceMappingURL=styles.js.map